import React from "react";
import { Link } from "react-router-dom";
import complaintIcon from "../assets/icons/complaint.svg";
import suggestionIcon from "../assets/icons/suggestion.svg";
import governanceIcon from "../assets/icons/governance.svg";
import resourcesIcon from "../assets/icons/resources.svg";
import trackIcon from "../assets/icons/track.svg";
import initiativesIcon from "../assets/icons/initiatives.png";
import transparentIcon from "../assets/icons/transparent.png";
import accountableIcon from "../assets/icons/accountable.png";
import responsiveIcon from "../assets/icons/responsive.png";

const Home = () => {
  return (
    <div className="container">
      {/* Banner Section - Image Banner */}
      <div
        className="banner"
        style={{
          // borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "clamp(25px, 4vw, 40px)",
          boxShadow: "0 8px 32px rgba(1, 65, 28, 0.2)",
          transition: "all 0.3s ease",
          position: "relative",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 12px 48px rgba(1, 65, 28, 0.3)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "0 8px 32px rgba(1, 65, 28, 0.2)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <img
          src="/whatsapp-image-banner.png"
          alt="Agriculture Department KP - E-Minister Portal"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            objectFit: "cover",
          }}
        />
      </div>

      {/* Hero Section */}
      <div className="hero">
        <h1>
          Welcome To <span className="highlight">E-Minister Portal</span>
        </h1>
        <p>
          Your voice matters! Submit complaints and suggestions directly to the
          Minister of Agriculture Department of Khyber Pakhtunkhwa. Help us
          build a better Pakistan together.
        </p>
        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          <Link
            to="/submit-complaint"
            className="btn btn-gold"
            style={{
              minWidth: "200px",
              position: "relative",
              overflow: "hidden",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              backgroundColor: "white",
              color: "var(--pakistan-green)",
              // border: "2px solid var(--pakistan-green)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(249, 168, 38, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow =
                "0 4px 15px rgba(249, 168, 38, 0.3)";
            }}
          >
            <span style={{ position: "relative", zIndex: 1 }}>
              File a Complaint
            </span>
          </Link>

          <Link
            to="/submit-suggestion"
            className="btn btn-primary"
            style={{
              minWidth: "200px",
              position: "relative",
              overflow: "hidden",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              backgroundColor: "white",
              color: "var(--pakistan-green)",
              border: "2px solid var(--pakistan-green)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-3px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(249, 168, 38, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(249, 168, 38, 0.4)";
            }}
          >
            <span style={{ position: "relative", zIndex: 1 }}>
              Give a Suggestion
            </span>
          </Link>
        </div>
      </div>

      {/* ===== NEW HEADING ADDED ABOVE CARDS ===== */}
      <div
        style={{
          textAlign: "center",
          padding: "20px 20px 10px 20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <h2
          style={{
            color: "#01411C",
            fontSize: "clamp(24px, 3vw, 36px)",
            fontWeight: "700",
            marginBottom: "8px",
            letterSpacing: "-0.5px",
          }}
        >
          Our Services
        </h2>
        <p
          style={{
            color: "#666",
            fontSize: "clamp(14px, 1.2vw, 18px)",
            maxWidth: "650px",
            margin: "0 auto",
          }}
        >
          Explore the different ways you can engage with the Agriculture
          Department
        </p>
        <div
          style={{
            width: "80px",
            height: "4px",
            background: "linear-gradient(90deg, #01411C, #F9A826)",
            margin: "12px auto 0",
            // borderRadius: "2px",
          }}
        />
      </div>

      {/* Feature Cards - Responsive Grid - 6 Cards */}
      <div
        className="feature-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "24px",
          padding: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Card 1: File a Complaint */}
        <Link to="/submit-complaint" style={{ textDecoration: "none" }}>
          <div
            className="feature-card"
            style={{
              background: "white",
              // borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(1, 65, 28, 0.08)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              cursor: "pointer",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(1, 65, 28, 0.15)";
              e.currentTarget.style.borderColor = "var(--pakistan-gold)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
              e.currentTarget.style.borderColor = "rgba(1, 65, 28, 0.08)";
            }}
          >
            <div
              className="icon-wrapper"
              style={{
                marginBottom: "16px",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.2) rotate(-10deg)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1) rotate(0)";
              }}
            >
              <img
                src={complaintIcon}
                alt="File a Complaint"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <h3
              style={{
                color: "#01411C",
                marginBottom: "12px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              File a Complaint
            </h3>
            <p
              style={{
                color: "#555",
                lineHeight: "1.6",
                flex: "1",
                margin: "0 auto",
                maxWidth: "90%",
              }}
            >
              Report issues in your area. From healthcare to infrastructure,
              we're here to listen.
            </p>
            <span
              style={{
                display: "inline-block",
                marginTop: "15px",
                color: "var(--pakistan-gold)",
                fontWeight: "600",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              Learn More →
            </span>
          </div>
        </Link>

        {/* Card 2: Give a Suggestion */}
        <Link to="/submit-suggestion" style={{ textDecoration: "none" }}>
          <div
            className="feature-card"
            style={{
              background: "white",
              // borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(1, 65, 28, 0.08)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              cursor: "pointer",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(1, 65, 28, 0.15)";
              e.currentTarget.style.borderColor = "var(--pakistan-gold)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
              e.currentTarget.style.borderColor = "rgba(1, 65, 28, 0.08)";
            }}
          >
            <div
              className="icon-wrapper"
              style={{
                marginBottom: "16px",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.2) rotate(10deg)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1) rotate(0)";
              }}
            >
              <img
                src={suggestionIcon}
                alt="Give a Suggestion"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <h3
              style={{
                color: "#01411C",
                marginBottom: "12px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Give a Suggestion
            </h3>
            <p
              style={{
                color: "#555",
                lineHeight: "1.6",
                flex: "1",
                margin: "0 auto",
                maxWidth: "90%",
              }}
            >
              Share innovative ideas for KP's development. Your suggestions can
              shape the future.
            </p>
            <span
              style={{
                display: "inline-block",
                marginTop: "15px",
                color: "var(--pakistan-gold)",
                fontWeight: "600",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              Learn More →
            </span>
          </div>
        </Link>

        {/* Card 3: Track Complaint Status */}
        <Link to="/complaint-status" style={{ textDecoration: "none" }}>
          <div
            className="feature-card"
            style={{
              background: "white",
              // borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(1, 65, 28, 0.08)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              cursor: "pointer",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(1, 65, 28, 0.15)";
              e.currentTarget.style.borderColor = "var(--pakistan-gold)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
              e.currentTarget.style.borderColor = "rgba(1, 65, 28, 0.08)";
            }}
          >
            <div
              className="icon-wrapper"
              style={{
                marginBottom: "16px",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.2) rotate(-5deg)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1) rotate(0)";
              }}
            >
              <img
                src={trackIcon}
                alt="Track Complaint Status"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <h3
              style={{
                color: "#01411C",
                marginBottom: "12px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Track Complaint Status
            </h3>
            <p
              style={{
                color: "#555",
                lineHeight: "1.6",
                flex: "1",
                margin: "0 auto",
                maxWidth: "90%",
              }}
            >
              Check the real-time status of your complaints. Stay informed about
              the progress and resolution of your issues.
            </p>
            <span
              style={{
                display: "inline-block",
                marginTop: "15px",
                color: "var(--pakistan-gold)",
                fontWeight: "600",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              Track Now →
            </span>
          </div>
        </Link>

        {/* Card 4: Transparent Governance */}
        <div
          className="feature-card"
          style={{
            background: "white",
            // borderRadius: "12px",
            padding: "24px",
            border: "1px solid rgba(1, 65, 28, 0.08)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            cursor: "pointer",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
            e.currentTarget.style.boxShadow =
              "0 12px 40px rgba(1, 65, 28, 0.15)";
            e.currentTarget.style.borderColor = "var(--pakistan-gold)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0) scale(1)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
            e.currentTarget.style.borderColor = "rgba(1, 65, 28, 0.08)";
          }}
        >
          <div
            className="icon-wrapper"
            style={{
              marginBottom: "16px",
              transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              width: "64px",
              height: "64px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <img
              src={governanceIcon}
              alt="Transparent Governance"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
          <h3
            style={{
              color: "#01411C",
              marginBottom: "12px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            Transparent Governance
          </h3>
          <p
            style={{
              color: "#555",
              lineHeight: "1.6",
              flex: "1",
              margin: "0 auto",
              maxWidth: "90%",
            }}
          >
            All complaints and suggestions are reviewed by the Minister's office
            with full transparency.
          </p>
          <span
            style={{
              display: "inline-block",
              marginTop: "15px",
              color: "var(--pakistan-gold)",
              fontWeight: "600",
              fontSize: "14px",
              transition: "all 0.3s ease",
            }}
          >
            Learn More →
          </span>
        </div>

        {/* Card 5: Government Resources */}
        <Link to="/resources" style={{ textDecoration: "none" }}>
          <div
            className="feature-card"
            style={{
              background: "white",
              // borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(1, 65, 28, 0.08)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              cursor: "pointer",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(1, 65, 28, 0.15)";
              e.currentTarget.style.borderColor = "var(--pakistan-gold)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
              e.currentTarget.style.borderColor = "rgba(1, 65, 28, 0.08)";
            }}
          >
            <div
              className="icon-wrapper"
              style={{
                marginBottom: "16px",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <img
                src={resourcesIcon}
                alt="Government Resources"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <h3
              style={{
                color: "#01411C",
                marginBottom: "12px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Government Resources
            </h3>
            <p
              style={{
                color: "#555",
                lineHeight: "1.6",
                flex: "1",
                margin: "0 auto",
                maxWidth: "90%",
              }}
            >
              Access other government portals and agricultural services
              including E-Secretary, AgriGIS, and Kissan Bazar.
            </p>
            <span
              style={{
                display: "inline-block",
                marginTop: "15px",
                color: "var(--pakistan-gold)",
                fontWeight: "600",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              Explore Resources →
            </span>
          </div>
        </Link>

        {/* Card 6: Minister's Initiatives */}
        <Link to="/initiatives" style={{ textDecoration: "none" }}>
          <div
            className="feature-card"
            style={{
              background: "white",
              // borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(1, 65, 28, 0.08)",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              cursor: "pointer",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
              e.currentTarget.style.boxShadow =
                "0 12px 40px rgba(1, 65, 28, 0.15)";
              e.currentTarget.style.borderColor = "var(--pakistan-gold)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
              e.currentTarget.style.borderColor = "rgba(1, 65, 28, 0.08)";
            }}
          >
            <div
              className="icon-wrapper"
              style={{
                marginBottom: "16px",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                width: "64px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.2) rotate(5deg)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1) rotate(0)";
              }}
            >
              <img
                src={initiativesIcon}
                alt="Minister's Initiatives"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <h3
              style={{
                color: "#01411C",
                marginBottom: "12px",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Minister's Initiatives
            </h3>
            <p
              style={{
                color: "#555",
                lineHeight: "1.6",
                flex: "1",
                margin: "0 auto",
                maxWidth: "90%",
              }}
            >
              Explore the latest development projects and initiatives led by the
              Minister for the progress of Khyber Pakhtunkhwa.
            </p>
            <span
              style={{
                display: "inline-block",
                marginTop: "15px",
                color: "var(--pakistan-gold)",
                fontWeight: "600",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
            >
              View Initiatives →
            </span>
          </div>
        </Link>
      </div>

      {/* Stats Section with Custom PNG Icons */}
      <div
        className="card"
        style={{
          textAlign: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e8f5e9 100%)",
          padding: "clamp(20px, 3vw, 30px)",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = "0 12px 40px rgba(1, 65, 28, 0.1)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = "var(--shadow-light)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        <h3
          style={{
            color: "var(--pakistan-green)",
            marginBottom: "10px",
            fontSize: "clamp(18px, 2vw, 24px)",
          }}
        >
          Building a Better Khyber Pakhtunkhwa
        </h3>
        <p
          style={{
            color: "#666",
            maxWidth: "600px",
            margin: "0 auto",
            fontSize: "clamp(14px, 1.2vw, 16px)",
          }}
        >
          Your participation in governance helps create a stronger, more
          responsive government that serves the people of Pakistan.
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "clamp(15px, 3vw, 30px)",
            marginTop: "20px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              transition: "all 0.3s ease",
              cursor: "default",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
            }}
          >
            <img
              src={transparentIcon}
              alt="Transparent"
              style={{
                width: "clamp(40px, 4vw, 48px)",
                height: "clamp(40px, 4vw, 48px)",
                objectFit: "contain",
                marginBottom: "5px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(12px, 1vw, 14px)",
                color: "#888",
                marginTop: "5px",
              }}
            >
              Transparent
            </p>
          </div>
          <div
            style={{
              transition: "all 0.3s ease",
              cursor: "default",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
            }}
          >
            <img
              src={accountableIcon}
              alt="Accountable"
              style={{
                width: "clamp(40px, 4vw, 48px)",
                height: "clamp(40px, 4vw, 48px)",
                objectFit: "contain",
                marginBottom: "5px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(12px, 1vw, 14px)",
                color: "#888",
                marginTop: "5px",
              }}
            >
              Accountable
            </p>
          </div>
          <div
            style={{
              transition: "all 0.3s ease",
              cursor: "default",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px) scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
            }}
          >
            <img
              src={responsiveIcon}
              alt="Responsive"
              style={{
                width: "clamp(40px, 4vw, 48px)",
                height: "clamp(40px, 4vw, 48px)",
                objectFit: "contain",
                marginBottom: "5px",
              }}
            />
            <p
              style={{
                fontSize: "clamp(12px, 1vw, 14px)",
                color: "#888",
                marginTop: "5px",
              }}
            >
              Responsive
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
